import { memo, useRef } from 'react'

import dynamic from 'next/dynamic'

import Header from 'modules/landing-page-layout/header'

import Registration from './registration'

const Footer = dynamic(() => import('modules/landing-page-layout/footer'))

const Subdelegated = memo(() => {
  const form = useRef<HTMLElement>(null)
  return (
    <>
      <Header />
      <Registration ref={form} />
      <Footer />
    </>
  )
})

Subdelegated.displayName = 'Subdelegated'

export default Subdelegated
